import { EMPTY_FUNCTION, EMPTY_STRING } from '../../../../constants/common'
import {
  AITextGeneration,
  AITextGenerationDraftPanel,
} from '../../../AITextGeneration'
import { FormikForm } from '../../../Formik'

import {
  DEMO_INITIAL_VALUES,
  MOCK_GENERATED_TEXT,
  MOCK_PROMPT_TEXT,
} from './AITextGenerationFieldDraftLibrary.mocks'

import * as styles from '../../../AITextGenerationField/AITextGenerationField.module.css'

function AITextGenerationFieldDraftLibrary() {
  return (
    <>
      <FormikForm initialValues={DEMO_INITIAL_VALUES} onSubmit={EMPTY_FUNCTION}>
        <div className={styles.AITextGenerationField}>
          <div className={styles.fieldArea}>
            <AITextGenerationDraftPanel
              showAiNotice
              generatedText={MOCK_GENERATED_TEXT}
              hasExistingContent={false}
              isCopied={false}
              promptText={MOCK_PROMPT_TEXT}
              onApply={EMPTY_FUNCTION}
              onCopy={EMPTY_FUNCTION}
              onDiscard={EMPTY_FUNCTION}
              onInsertBelow={EMPTY_FUNCTION}
              onRegenerate={EMPTY_FUNCTION}
              onReplace={EMPTY_FUNCTION}
            />
          </div>

          <AITextGeneration
            className={styles.generationForm}
            fieldContent={EMPTY_STRING}
            onGenerate={EMPTY_FUNCTION}
            onGenerateStart={EMPTY_FUNCTION}
            onGenerateStop={EMPTY_FUNCTION}
          />
        </div>
      </FormikForm>
      <FormikForm initialValues={DEMO_INITIAL_VALUES} onSubmit={EMPTY_FUNCTION}>
        <div className={styles.AITextGenerationField}>
          <div className={styles.fieldArea}>
            <AITextGenerationDraftPanel
              isLoading
              showAiNotice
              generatedText={MOCK_GENERATED_TEXT}
              hasExistingContent={false}
              isCopied={false}
              promptText={MOCK_PROMPT_TEXT}
              onApply={EMPTY_FUNCTION}
              onCopy={EMPTY_FUNCTION}
              onDiscard={EMPTY_FUNCTION}
              onInsertBelow={EMPTY_FUNCTION}
              onRegenerate={EMPTY_FUNCTION}
              onReplace={EMPTY_FUNCTION}
            />
          </div>

          <AITextGeneration
            isLoading
            className={styles.generationForm}
            fieldContent={EMPTY_STRING}
            onGenerate={EMPTY_FUNCTION}
            onGenerateStart={EMPTY_FUNCTION}
            onGenerateStop={EMPTY_FUNCTION}
          />
        </div>
      </FormikForm>
    </>
  )
}

export default AITextGenerationFieldDraftLibrary
